import { useState, useEffect } from 'react';
import { fetchEligibility, type EligibilityGroup } from '../services/optionsService';

interface Result {
  groups: EligibilityGroup[];
  loading: boolean;
}

export function useEligibility(lang: string): Result {
  const [state, setState] = useState<Result>({ groups: [], loading: true });

  useEffect(() => {
    let cancelled = false;
    fetchEligibility(lang)
      .then((data) => {
        if (!cancelled) setState({ groups: data, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ groups: [], loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [lang]);

  return state;
}
